import dot from 'dot-prop-immutable';

import { types } from './actions';

const initialState = {
  opDefs: [],
  isCreateModalOpen: false,
  isCreating: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.INIT:
      return {
        ...state,
        opDefs: action.payload.opDefs,
      };
    case types.NEW_OP_DEF_MODAL_OPEN:
      return dot.set(state, 'isCreateModalOpen', true);
    case types.NEW_OP_DEF_MODAL_CLOSE:
      return dot.set(state, 'isCreateModalOpen', false);
    case types.CREATE_REQUEST:
      return dot.set(state, 'isCreating', true);
    case types.CREATE_SUCCESS: {
      return {
        ...state,
        isCreating: false,
        isCreateModalOpen: false,
        opDefs: [...state.opDefs, action.payload.opDef],
      };
    }
    case types.CREATE_ERROR:
      return dot.set(state, 'isCreating', false);
    default:
      return state;
  }
};

export default reducer;

export const getScope = (state) => state.modules.opDefs.listPage;

export const getIsCreateModalOpen = (state) =>
  getScope(state).isCreateModalOpen;

export const getIsCreating = (state) => getScope(state).isCreating;

export const getOpDefs = (state) => getScope(state).opDefs;

export const getOpDef = (state, id) => {
  return getOpDefs(state).find((opDef) => opDef.id === id) || null;
};
